import { render, staticRenderFns } from "./DepositedOrder.vue?vue&type=template&id=194091e5&"
import script from "./DepositedOrder.vue?vue&type=script&lang=js&"
export * from "./DepositedOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports